import S from './primary-background.styles';

export const PrimaryBackground = S.StyledPrimaryBackground;
